import { ReactElement } from 'react';

import type { Segment, SegmentSelectionStateType, SelectionState } from './types';
import { segmentSelectionTotState, SegmentSpan } from './SegmentSpan';

export function Segments({
  segments,
  selectionState,
}: {
  segments: Segment[];
  selectionState: SelectionState;
}): ReactElement | null {
  if (segments.length === 0) {
    return null;
  }

  const selection = selectionState?.type === 'segment' ? selectionState : undefined;

  return (
    <>
      {segments.map((segment) => {
        const selected = selection?.id === segment.id;

        if (selected) {
          return (
            <SegmentSpan
              state={segmentSelectionTotState(selectionState as SegmentSelectionStateType)}
              key={selection.id}
              left={selection.left}
              width={selection.width}
              start={selection.start}
              end={selection.end}
              undersized={selection.undersized}
              misaligned={!selection.aligned}
              error={selection.error}
            >
              {selection.quantity}
            </SegmentSpan>
          );
        }
        return (
          <SegmentSpan
            state="segment-idle"
            key={segment.id}
            left={segment.left}
            width={segment.width}
            start={segment.start}
            end={segment.end}
            undersized={segment.undersized}
            misaligned={!segment.aligned}
          >
            {segment.quantity}
          </SegmentSpan>
        );
      })}
    </>
  );
}
